export default __webpack_public_path__ + "static/media/1.16cbc00e.jpg";